// =========================================================
// Vojjin REGEX TEST Utilities
// =========================================================

;(function (global) {
    // Create namespace
    const G = global.gemini || (global.gemini = {});
    G.test = {};

    function pregCheck(string, pattern) {
        if (gemini.utils.isEmpty(string)) return false;
        return pattern.test(string);
    }

    G.test.url = function (url) {
        return pregCheck(url, /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/);
    }

    G.test.email = function (email) {
        return pregCheck(email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    }

    G.test.login = function (login) {
        return pregCheck(login, /^[a-zA-Z0-9_\- ]{3,16}$/);
    }

    G.test.player_id = function (player_id) {
        return pregCheck(player_id, /^[a-zA-Z0-9_\- ]{1,8}$/);
    }

    G.test.coupon = function (coupon) {
        return pregCheck(coupon, /^[a-zA-Z0-9\_\-\!\.]{1,50}$/);
    }


    if (typeof module !== "undefined" && module.exports) {
        module.exports = G.test;
    } else {
        global.gemini = G;
        global.gemini.test = G.test;
    }
})(typeof globalThis !== "undefined" ? globalThis : this);
